module.exports = __webpack_public_path__ + "708e2295eab13cacbd3f0dcc8efc9ee2.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/stat-nationalpark.png
// module id = 178
// module chunks = 0